<template>
    <td colspan="999">
        <vrm-foldable-table :items="users" key-by="id" class="table-users-padding">
            <template v-slot:thead>
                <th>{{ $t('users.members', 'Members') }}</th>
            </template>
            <template v-slot:main="{ item: user }">
                <vrm-table-cell-user :user="user"></vrm-table-cell-user>
            </template>
        </vrm-foldable-table>
    </td>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmFoldableTable from '@/vue/components/molecules/VrmFoldableTable';
import VrmTableCellUser from '@/vue/components/table/VrmTableCellUser';

@Component({
    components: { VrmFoldableTable, VrmTableCellUser },
})
@AngularLocaleBundle('users')
export default class VrmTableUsersNames extends Vue {
    @Prop()
    users;
}
</script>
